import { DeleteTwoTone, EditTwoTone, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import UpdatesService, {
  ReleaseUpdateTypeOptions,
} from "../../Services/UpdatesService";
import { Col, Row, Spin, Table, Input, Button, Select, Typography, Popconfirm } from "antd";
import { ColumnsType } from "antd/es/table";
import React from "react";
import { adminContext } from "../../Common/PageRoute";
import UpdateDetails from "./UpdateDetails";
import Link from "antd/es/typography/Link";
import { Utils } from "../../Utilities/Utils";
import { Dayjs } from "dayjs";
import CustomRangePicker from "../../Common/Custom Components/Ant design/RangePicker";
import { PageLayout, PageHeader, SectionCard, TableToolbar } from "../../Common/Layout";

interface ListDataType {
  id: number;
  name: string;
  phoneNumber: string;
  email: string;
  createdBy: any;
  updatedBy: any;
}
interface ListData {
  items: ListDataType[];
  totalItems: number;
}

const ReleaseUpdateTypesShow = [
  "Unknown",
  "Enhancement",
  "Development",
  "Bug Fixes"
]


const Updates = () => {
  const { openNotification } = React.useContext(adminContext);
  const [updatesList, setUpdatesList] = React.useState<ListData>({
    items: [],
    totalItems: 0,
  });
  const [loading, setLoading] = React.useState(false);
  const [versionList, setVersionList] = React.useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [versionLoading, setVersionLoading] = React.useState<boolean>(false);
  const [selectedDate, setSelectedDate] = React.useState<{
    fromDate: Dayjs | null,
    toDate: Dayjs | null
  }
  >({
    fromDate: null,
    toDate: null,
  })
  const [defaultVersion, setDefaultVersion] = React.useState("");
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [refresh, setRefresh] = React.useState(false);
  const [dialog, setDialog] = React.useState<{ type: string; params: any }>({
    type: "",
    params: {},
  });
  // const [pagingItems, setPagingItems] = React.useState({

  // });
  const [listParams, setListParams] = React.useState({
    search: "",
    sortDir: "descend",
    sortCol: "CreatedBy.Date",
    totalRecords: 0,
    currentPage: 1,
    pageSize: 15,
    type: [],
    versions: [],
  });

  const getItems = async (start: any, length: any) => {
    let res = await UpdatesService.getUpdatesList(
      selectedDate.fromDate ? selectedDate.fromDate?.format("DD-MM-YYYY") : "",
      selectedDate.toDate ? selectedDate.toDate?.format("DD-MM-YYYY") : "",
      start,
      length,
      listParams.search,
      listParams.sortCol,
      listParams.sortDir,
      listParams.type,
      listParams.versions,
    );
    if (res?.status) {
      setLoading(false);

      setUpdatesList({
        totalItems: res?.result?.totalRecords,
        items: res?.result?.items,
      });
      setDefaultVersion(res?.result?.items[0]);
      //   setPagingItems({...pagingItems, totalRecords: res?.result?.totalRecords})
    } else {
      openNotification("error", res.message);
      //setNotification(notific);
      setLoading(false);
    }
  };
  React.useEffect(() => {
    setLoading(true);
    getItems(
      (listParams.currentPage - 1) * listParams.pageSize,
      listParams.pageSize,
    );
    // if(refresh === true) setRefresh(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listParams, refresh, selectedDate]);

  const handleDelete = async (id: any) => {
    let res = await UpdatesService.deleteUpdate(id);
    if (res?.result) {
      setRefresh((x) => (x = !x));
      openNotification("success", "Release deleted successfully");
    } else {
      openNotification("error", res.message);
    }
  };

  const getReleaseVersionList = async () => {
    try {
      setVersionLoading(true);
      var res = await UpdatesService.getVersionsList();
      if (res?.status) {
        const list = res?.result?.map((version: string) => ({
          value: version,
          label: version,
        }));
        setVersionList(list);
      }
    } catch (error) {
      openNotification("error", "Failed to fetch versions");
    } finally {
      setVersionLoading(false);
    }
  };

  React.useEffect(() => {
    getReleaseVersionList();
  }, []);

  const columns: ColumnsType<ListDataType> = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      width: "4%",
      render: (_: any, record: any, index: any) => (
        <p>
          {listParams.currentPage > 1
            ? listParams.pageSize * (listParams.currentPage - 1) + index + 1
            : index + 1}
        </p>
      ),
    },
    {
      title: "Date",
      dataIndex: "createdBy.date",
      key: "CreatedBy.Date",
      width: "8%",
      sorter: true,
      showSorterTooltip: false,
      render: (text: any, record: any) => (
        <span>
          {
            Utils.getFormattedDate(record?.createdBy?.date)
            //  dayjs(record?.createdBy?.date).format("DD-MM-YYYY")
          }
        </span>
      ),
    },
    {
      title: "Version",
      dataIndex: "version",
      width: "8%",
      key: "Version",
      // sorter: true,
      // showSorterTooltip: false,
    },
    {
      title: "Type",
      dataIndex: "type",
      width: "11%",
      key: "type",
      render: (text: any, record: any) => (
        <span>{ReleaseUpdateTypesShow[record?.type]}</span>
      ),
    },
    {
      title: "Title",
      width: "20%",
      dataIndex: "title",
      key: "Title",
      sorter: true,
      showSorterTooltip: false,
      render: (text: string) => (
        <Typography.Text
          ellipsis={{
            tooltip: {
              title: text,
              placement: "topLeft",
              overlayStyle: { maxWidth: 600 },
            },
          }}
        >
          {text}
        </Typography.Text>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "Description",
      width: 400,
      render: (_, record: any) => (
        <Typography.Paragraph
          style={{
            marginBottom: 0,
            marginTop: 0,
            height: 25,
            lineHeight: "25px",
          }}
          ellipsis={{
            rows: 1,
            tooltip: {
              title: (
                <div
                  dangerouslySetInnerHTML={{ __html: record?.description }}
                />
              ),
              placement: "topLeft",
              overlayStyle: { maxWidth: 700 },
            },
          }}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: record?.description
                ?.replace(/<p>/g, '<span style="margin:0; padding:0;">')
                .replace(/<\/p>/g, "</span>"),
            }}
          />
        </Typography.Paragraph>
      ),
    },
    {
      title: "Action",
      width: "7%",
      render: (_: any, record: any, index: any) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <Link
            className="edit-btn"
            onClick={() => {
              setDialog({ type: "editupdate", params: { record: record } });
            }}
          >
            <EditTwoTone />
          </Link>
          <Popconfirm
            title="Delete update"
            description="Are you sure you want to delete this release update?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Link className="delete-btn">
              <DeleteTwoTone twoToneColor="#ff4d4f" />
            </Link>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const primaryActions: any[] = [
    {
      label: "Release",
      icon: <PlusOutlined />,
      type: "primary",
      onClick: () => setDialog({ type: "editupdate", params: {} }),
    }
  ];

  const filterCriteria = [
    {
      key: "dateRange",
      label: "Date Range",
      type: "dateRange" as const,
    },
    {
      key: "versions",
      label: "Versions",
      type: "multiSelect" as const,
      options: versionList,
      placeholder: "Select Version",
    },
    {
      key: "types",
      label: "Types",
      type: "multiSelect" as const,
      options: ReleaseUpdateTypeOptions,
      placeholder: "Select Type",
    },
  ];

  const activeFilters = {
    dateRange: selectedDate.fromDate && selectedDate.toDate ? [selectedDate.fromDate, selectedDate.toDate] : undefined,
    versions: listParams.versions,
    types: listParams.type,
  };

  const handleFiltersChange = (newFilters: Record<string, any>) => {
    const dates = newFilters.dateRange || [null, null];
    setSelectedDate({
      fromDate: dates[0],
      toDate: dates[1],
    });
    setListParams({
      ...listParams,
      versions: newFilters.versions || [],
      type: newFilters.types || [],
      currentPage: 1,
    });
  };

  return (
    <PageLayout>
      <PageHeader title="Updates" subtitle="Release notes and version history" />
      <SectionCard noPadding>

        <div style={{ padding: "0 16px" }}>
          <TableToolbar
            primaryActions={primaryActions}
            onSearch={(val: string) => setListParams({ ...listParams, search: val, currentPage: 1 })}
            searchPlaceholder="Search updates..."
            filterCriteria={filterCriteria}
            activeFilters={activeFilters}
            onFiltersChange={handleFiltersChange}
            onRefresh={() => setRefresh(!refresh)}
          />
        </div>
        <Table
          dataSource={updatesList?.items}
          columns={columns}
          size="small"
          tableLayout="fixed"
          scroll={
            (updatesList?.items?.length || 0) > 15
              ? { x: 1200, y: window.innerHeight - 256 }
              : undefined
          }
          className="border-top-table"
          loading={{
            spinning: loading,
            indicator: (
              <Spin
                indicator={<LoadingOutlined style={{ fontSize: 20 }} spin />}
              />
            ),
          }}
          pagination={{
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
            current: listParams.currentPage,
            pageSize: listParams.pageSize,
            showSizeChanger: true,
            total: updatesList?.totalItems,
            pageSizeOptions: ["15", "25", "50", "100"],
          }}
          onChange={(paging, filter, sort: any) => {
            if (
              paging?.current !== undefined &&
              paging?.pageSize !== undefined
            ) {
              setLoading(true);
              setListParams({
                ...listParams,
                sortDir: sort.order !== undefined ? sort.order : "acsend",
                sortCol:
                  sort.order !== undefined
                    ? sort.columnKey
                    : "CreatedBy.Date",
                currentPage:
                  paging.current !== undefined ? paging.current : 1,
                pageSize:
                  paging.pageSize !== undefined ? paging.pageSize : 15,
              });
            }
          }}
        />
        {dialog.type === "editupdate" && (
          <UpdateDetails
            {...dialog.params}
            type={dialog.params.record ? "edit" : "add"}
            show={true}
            defaultVersion={defaultVersion}
            onDismiss={(confirmed: boolean) => {
              setDialog({ type: "", params: {} });
              if (confirmed) {
                setRefresh((x) => (x = !x));
              }
            }}
          />
        )}
      </SectionCard>
    </PageLayout>
  );
};

export default Updates;
